module.exports = __webpack_public_path__ + "static/media/internship.a6be5a75.png";